<template>
  <div>
    <div
      class="sub-header"
      data-test="sub-header"
    >
      Fill out some personal details
    </div>
    <div class="overflow-y-scroll scrollbar modal-height">
      <h5
        style="padding-bottom: 8px"
        class="inputs text-center md:text-left text-base"
        data-test="not-required-message"
      >
        Not all fields are required
      </h5>
      <AccountInfoForm
        :width="isMobile ? '200px' : '300px'"
        class="account-card"
        data-test="account-info-form"
      />
    </div>
  </div>
</template>

<script setup>
import useIsMobile from '@/composables/useIsMobile.js';

import AccountInfoForm from '@/components/settings/AccountInfoForm.vue';
const { isMobile } = useIsMobile();
</script>
